const header = document.querySelector("[data-header]");
const menuToggle = document.querySelector(".menu-toggle");
const mobileNav = document.querySelector(".mobile-nav");
const tabButtons = document.querySelectorAll(".tab-button");
const tabPanels = document.querySelectorAll(".tab-panel");
const mediaButton = document.querySelector("[data-media-button]");
const lightbox = document.querySelector("[data-lightbox]");
const closeLightbox = document.querySelector("[data-close-lightbox]");

function updateHeader() {
  if (header) {
    header.classList.toggle("is-scrolled", window.scrollY > 16);
  }
}

window.addEventListener("scroll", updateHeader, { passive: true });
updateHeader();

if (menuToggle && mobileNav) {
  menuToggle.addEventListener("click", () => {
    const isOpen = mobileNav.classList.toggle("is-open");
    menuToggle.setAttribute("aria-expanded", String(isOpen));
    menuToggle.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
  });

  mobileNav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      mobileNav.classList.remove("is-open");
      menuToggle.setAttribute("aria-expanded", "false");
      menuToggle.setAttribute("aria-label", "Open menu");
    });
  });
}

tabButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const tab = button.dataset.tab;

    tabButtons.forEach((item) => {
      const isActive = item === button;
      item.classList.toggle("is-active", isActive);
      item.setAttribute("aria-selected", String(isActive));
      item.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    tabPanels.forEach((panel) => {
      const isActive = panel.dataset.panel === tab;
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });
  });

  button.addEventListener("keydown", (event) => {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
    event.preventDefault();
    const buttons = Array.from(tabButtons);
    const currentIndex = buttons.indexOf(button);
    const nextIndex = event.key === "Home" ? 0 : event.key === "End" ? buttons.length - 1 :
      (currentIndex + (event.key === "ArrowRight" ? 1 : -1) + buttons.length) % buttons.length;
    buttons[nextIndex].focus();
    buttons[nextIndex].click();
  });
});

function openLightbox() {
  if (!lightbox) return;
  lightbox.classList.add("is-open");
  lightbox.setAttribute("aria-hidden", "false");
  document.body.classList.add("no-scroll");
  if (closeLightbox) closeLightbox.focus();
}

function hideLightbox() {
  if (!lightbox) return;
  lightbox.classList.remove("is-open");
  lightbox.setAttribute("aria-hidden", "true");
  document.body.classList.remove("no-scroll");
}

if (mediaButton) {
  mediaButton.addEventListener("click", openLightbox);
}

if (closeLightbox) {
  closeLightbox.addEventListener("click", hideLightbox);
}

if (lightbox) {
  lightbox.addEventListener("click", (event) => {
    if (event.target === lightbox) {
      hideLightbox();
    }
  });
}

document.querySelectorAll(".form-status").forEach((status) => status.focus());

window.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    hideLightbox();
  }
});
